import { render, staticRenderFns } from "./TiktokUserCenter.vue?vue&type=template&id=3cbed3af&scoped=true&"
import script from "./TiktokUserCenter.vue?vue&type=script&lang=js&"
export * from "./TiktokUserCenter.vue?vue&type=script&lang=js&"
import style0 from "./TiktokUserCenter.vue?vue&type=style&index=0&id=3cbed3af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cbed3af",
  null
  
)

component.options.__file = "TiktokUserCenter.vue"
export default component.exports